import { useState } from 'react';

export function useInputValue(initialValue) {
  const [inputValue, setInputValue] = useState(initialValue);

  const handleChange = (value, keyboardInputValue) => {
    setInputValue(keyboardInputValue);
  };

  return [inputValue, handleChange];
}
